import React, { Fragment } from "react";
import { compose } from "redux";
import { connect } from "react-redux";
import styled from "styled-components";
import _ from "lodash";
import moment from "moment";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Dialog, DialogTitle } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";

import { getDealPrepaymentAnalysis, exportDealPrepaymentResults } from './prepaymentCalculatorModel.store';

import { Transition, styles, dateMask, autoCorrectedDatePipe, EXCEL, PDF, ListItemLink, ExportButton } from "./CommonUtil";
import PrepaymentAnalysisResult from "./PrepaymentAnalysisResult"
import { StyledDialogContent, StyledMaterialDatePicker, VerticalDivider, ResultWrapper, ItemList, ExportControlContainer, HeaderLeftContainer, StyledDialogIconButton, StyledButtonWithPadding } from "./styles";

const MinHeightStyledDialogContent = styled(StyledDialogContent)`
  && { 
    min-height: 523px;
  }
`;

class PrepaymentCalculatorModel extends React.Component {
  state = {
    prepaymentDate: moment().format("MM/DD/YYYY"),
    selectedItem: {},
    overviews: [],
    loans: [],
    hedges: [],
    additionalInfoButtonText: 'show additional information'
  };

  componentDidMount() {
    this.calculatePrepayment();
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.props.dealPrepaymentAnalysis != null && this.props.dealPrepaymentAnalysis != prevProps.dealPrepaymentAnalysis && this.props.dealPrepaymentAnalysis.PrepaymentResults && this.props.dealPrepaymentAnalysis.PrepaymentResults.length > 0) {

      const results = this.breakOutResults();
      this.setState({
        overviews: results.overviews,
        loans: results.loans,
        hedges: results.hedges,
        selectedItem: results.overviewAsDefault ? results.overviews[0] : results.loans[0]
      });

    }
  };

  handleDateChange = (selectedOption) => {
    this.setState({
      prepaymentDate: selectedOption ? moment(selectedOption).format("MM/DD/YYYY") : null
    });
  };

  calculatePrepayment = () => {
    const prepaymentDate = moment(this.state.prepaymentDate).format("YYYY-MM-DD");
    this.props.getDealPrepaymentAnalysis({
      dealId: this.props.dealId,
      prepaymentDate: prepaymentDate
    });
  };

  breakOutResults = () => {
    let results = this.props.dealPrepaymentAnalysis.PrepaymentResults;
    const overviews = results.filter(x => x.isOverview);
    const loans = results.filter(x => x.isLoan);
    const hedges = results.filter(x => x.isHedge);
    const overviewAsDefault = loans.length > 1 || hedges.length > 0;
    return { overviews, loans, hedges, overviewAsDefault }
  };

  tabSelectionClick = (item) => {
    this.setState({
      selectedItem: item,
      isAdditionalInfoOpen: false,
    });
  }

  toggleAdditionalInfo = () => {
    if (this.state.isAdditionalInfoOpen) {
      this.setState({
        isAdditionalInfoOpen: false,
        additionalInfoButtonText: 'show additional information'
      })
    } else {
      this.setState({
        isAdditionalInfoOpen: true,
        additionalInfoButtonText: 'hide additional information'
      })
    }
  }

  exportResults = (format) => this.props.exportDealPrepaymentResults({ format: format, results: this.state.selectedItem });

  renderUnavailableCopy = () => {
    return (
      <p>
        Prepayment details not available for this Deal.
        <br />
        Open <a href="/calculators/prepayment">stand-alone Prepayment calculator</a> to enter information.
      </p>
    );
  };

  render() {
    const { overviews, loans, hedges } = this.state;
    const { isOpen } = this.props;
    if (!isOpen) return null;
    let loansToRender = JSON.parse(JSON.stringify(loans)); //copy to break references
    loansToRender = loansToRender.filter(loan => { return (loan.isLoan && !loan.label.includes("Loan Seniority Type not set")) });


    return (
      <Fragment>
        <Dialog
          id="prepaymentCalculatorModel"
          maxWidth={"md"}
          open={isOpen}
          onClose={this.props.closemodal}
          scroll={"paper"}
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="form-dialog-title">
            Prepayment Calculator
            <StyledDialogIconButton onClick={this.props.closeModal}>
              <CloseIcon id="closeIcon" style={{ fontSize: 22 }} />
            </StyledDialogIconButton>
          </DialogTitle>



          <MinHeightStyledDialogContent>
            {loansToRender.length === 0 && this.renderUnavailableCopy()}
            {loansToRender.length > 0 && (
              <Fragment>
                <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                  <HeaderLeftContainer item xs={9}>
                    <Grid container direction="row" justify="flex-start" alignItems="center" spacing={8}>
                      <Grid item xs={5} sm={5} md={5} lg={5} xl={5}>
                        <StyledMaterialDatePicker label="Prepayment Date"
                          name="prepaymentDate"
                          keyboard={true}
                          InputProps={{ disableUnderline: true, }}
                          mask={dateMask}
                          invalidDateMessage={null}
                          maxDateMessage={null}
                          minDateMessage={null}
                          invalidLabel=''
                          pipe={autoCorrectedDatePipe} disableOpenOnEnter
                          format="MM/DD/YYYY"
                          value={this.state.prepaymentDate}
                          onChange={this.handleDateChange} />
                      </Grid>
                      <Grid item xs={2} sm={2} md={2} lg={2} xl={2}>
                        <StyledButtonWithPadding id="calculatebutton" onClick={this.calculatePrepayment}>Calculate</StyledButtonWithPadding>
                      </Grid>
                    </Grid>
                  </HeaderLeftContainer>
                  <Grid item xs={2}>
                    {this.state.selectedItem.isLoan && this.state.selectedItem.prepaymentType !== "NONE" && (
                      <ExportControlContainer container direction="row" justify="flex-start" alignItems="right" spacing={8}>
                        <Grid item><ExportButton label="EXCEL" exportClick={() => this.exportResults(EXCEL)} /></Grid>
                        <Grid item><VerticalDivider /></Grid>
                        <Grid item><ExportButton label="PDF" exportClick={() => this.exportResults(PDF)} /></Grid>
                      </ExportControlContainer>
                    )}
                  </Grid>
                </Grid>
                <hr />
                <Grid container justify="space-between" spacing={24}>
                  <Grid item xs={6} sm={6} md={6} lg={6} xl={6} >
                    <ItemList id="closedLoansList">
                      {(loansToRender.length > 1 || hedges.length > 0) && overviews.map(prepaymentItem => {
                        return (<ListItemLink
                          key={prepaymentItem.id}
                          isSelected={prepaymentItem.id === this.state.selectedItem.id}
                          item={prepaymentItem}
                          label={prepaymentItem.label}
                          handleClick={this.tabSelectionClick} />)
                      })}
                      {loansToRender.map(prepaymentItem => {
                        return (<ListItemLink
                          key={prepaymentItem.id}
                          isSelected={prepaymentItem.id === this.state.selectedItem.id}
                          item={prepaymentItem}
                          label={prepaymentItem.label}
                          handleClick={this.tabSelectionClick} />)
                      })}
                      {hedges.map(prepaymentItem => {
                        return (<ListItemLink
                          key={prepaymentItem.id}
                          isSelected={prepaymentItem.id === this.state.selectedItem.id}
                          item={prepaymentItem}
                          label={prepaymentItem.label}
                          handleClick={this.tabSelectionClick} />)
                      })}

                    </ItemList>
                  </Grid>
                  <ResultWrapper item xs={6} sm={6} md={6} lg={6} xl={6} >
                    <PrepaymentAnalysisResult
                      isAdditionalInfoOpen={this.state.isAdditionalInfoOpen}
                      toggleAdditionalInfo={this.toggleAdditionalInfo}
                      prepaymentResult={this.state.selectedItem}
                      additionalInfoButtonText={this.state.additionalInfoButtonText} />
                  </ResultWrapper>
                </Grid>
              </Fragment>
            )}
          </MinHeightStyledDialogContent>
        </Dialog>
      </Fragment>
    );
  }
}


const mapStateToProps = ({ prepaymentCalculator }) => {
  return ({
    ...prepaymentCalculator
  })
};

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    {
      getDealPrepaymentAnalysis,
      exportDealPrepaymentResults
    }
  ))(PrepaymentCalculatorModel);
